export default "__VITE_ASSET__DCja5ky2__"